var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarFillHalfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45951 6.25911L8.0026 3.32713V10.7132L10.918 12.2343L10.3604 9.01301L12.7199 6.7309L9.45951 6.25911ZM12.4163 13.0743C12.5285 13.7248 11.8381 14.2097 11.2599 13.9079L8.0026 12.2085L4.74529 13.9079C4.1671 14.2121 3.47676 13.7248 3.5889 13.0743L4.21196 9.47509L1.57769 6.92723C1.10417 6.4696 1.36586 5.67061 2.01881 5.57661L5.65993 5.04972L7.28734 1.77461C7.58142 1.18341 8.42628 1.19083 8.71787 1.77461L10.3453 5.04972L13.9864 5.57661C14.6394 5.67061 14.901 6.4696 14.4275 6.92723L11.7933 9.47509L12.4163 13.0743Z",
    fill: "#FFA446"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFillHalfIcon);
export default __webpack_public_path__ + "static/media/starFillHalfIcon.8eb84a48.svg";
export { ForwardRef as ReactComponent };